module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paged-quotes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row paged-quotes__controls"
  }, [_c('div', {
    staticClass: "col-6-sm"
  }, [(_vm.prevVisible) ? _c('div', {
    staticClass: "paged-quotes__nav-btn",
    on: {
      "click": function($event) {
        _vm.prevHandler()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" terug\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6-sm"
  }, [(_vm.nextVisible) ? _c('div', {
    staticClass: "paged-quotes__nav-btn",
    on: {
      "click": function($event) {
        _vm.nextHandler()
      }
    }
  }, [_vm._v("\n                     verder "), _c('span', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, _vm._l((_vm.currentQuotes), function(quote) {
    return _c('div', {
      staticClass: "paged-quotes__item quote"
    }, [_vm._v("\n                    " + _vm._s(quote.quote) + "\n                ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1a2b82","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paged-quotes/paged-quotes.vue
// module id = 149
// module chunks = 0